import { defineComponent as v, mergeModels as w, useModel as x, computed as t, useAttrs as d, createElementBlock as f, openBlock as c, createElementVNode as o, normalizeClass as l, withDirectives as k, mergeProps as y, vModelCheckbox as C, createCommentVNode as V, toDisplayString as N, renderSlot as z } from "vue";
import { omit as B } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
const M = { class: "isolate" }, _ = ["disabled"], A = { class: "flex min-w-0 flex-col" }, T = /* @__PURE__ */ v({
  name: "RevToggle",
  inheritAttrs: !1,
  __name: "Toggle",
  props: /* @__PURE__ */ w({
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    position: { default: "left" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(r) {
    const a = r, i = x(r, "modelValue"), u = t(() => B(d(), ["class"])), b = t(() => [
      d().class,
      e`group flex cursor-pointer items-center gap-12`,
      a.position === "sticked" && e`justify-between`
    ]), p = t(() => [
      e`bg-static-default-low border-action-default-low peer-focus-visible-outline-default-hi`,
      e`rounded-lg relative flex h-24 w-[46px] shrink-0 cursor-pointer items-center`,
      e`border`,
      e`before:text-action-default-low before:shadow-long before:rounded-full`,
      e`after:bg-action-default-min-hover after:rounded-full`,
      e`peer-checked:bg-action-success-hi peer-checked:before:bg-action-default-low`,
      e`peer-disabled:bg-static-default-low-disabled peer-disabled:border-action-default-low-disabled peer-disabled:before:text-action-default-low-disabled peer-disabled:peer-checked:bg-action-success-hi-disabled`,
      e`before:absolute before:left-3 before:size-16 before:border-transparent before:bg-current before:content-['']`,
      e`after:pointer-events-none after:absolute after:right-9 after:z-[-1] after:size-48 after:opacity-0 after:content-['']`,
      e`peer-checked:border-none peer-checked:before:size-20 peer-checked:before:translate-x-[21px] peer-checked:after:translate-x-[21px]`,
      e`peer-hover:after:opacity-100`,
      e`peer-disabled:before:bg-current peer-disabled:before:shadow-none peer-disabled:after:hidden`,
      e`motion-safe:transition-all motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      e`before:motion-safe:transition-all before:motion-safe:duration-[400ms] before:motion-safe:ease-in-out`,
      e`after:motion-safe:transition-all after:motion-safe:duration-[400ms] after:motion-safe:ease-in-out`,
      a.position !== "left" && e`order-1`
    ]), m = t(() => [
      e`body-1 line-clamp-2 motion-safe:transition-colors motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      a.disabled ? e`text-action-default-hi-disabled` : e`text-action-default-hi`
    ]), h = t(() => [
      e`body-2 motion-safe:transition-colors motion-safe:duration-[400ms] motion-safe:ease-in-out`,
      a.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (s, n) => (c(), f("div", M, [
      o("label", {
        class: l(b.value)
      }, [
        k(o("input", y(u.value, {
          "onUpdate:modelValue": n[0] || (n[0] = (g) => i.value = g),
          class: "peer sr-only",
          disabled: s.disabled,
          type: "checkbox"
        }), null, 16, _), [
          [C, i.value]
        ]),
        o("span", {
          class: l(p.value)
        }, null, 2),
        o("span", A, [
          o("span", {
            class: l(m.value)
          }, N(s.label), 3),
          s.$slots.default ? (c(), f("span", {
            key: 0,
            class: l(h.value)
          }, [
            z(s.$slots, "default")
          ], 2)) : V("", !0)
        ])
      ], 2)
    ]));
  }
});
export {
  T as default
};
